import {
    GET_ALL_ORDERS,
    GET_DETAILS_SERVICES,
    GET_SERVICES,
    SET_EDIT_SERVICE,
    SET_SERVICE,
    SET_UPDATE,
    SET_MDF,
    SET_IDGROUP,
    SET_NAME
} from "../action/finalproduct";








const initialState = {

    mobile: null,

}




export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SERVICE:
            return { ...state, data: action.data };
        case SET_EDIT_SERVICE:
            return { ...state, data: action.data };
        case GET_SERVICES:
            return { ...state, data: action.data };
        case GET_DETAILS_SERVICES:
            return { ...state, data: action.data };
        case GET_ALL_ORDERS:
            return { ...state, data: action.data };
        case SET_UPDATE:
            return { ...state, data: action.data };
            case SET_MDF:
            return { ...state, datamdf: action.data };
            case SET_IDGROUP:
            return { ...state, datagroup: action.data };
            case SET_NAME:
            return { ...state, data: action.data };

        default:
            return state;
    }
}
